import { render, staticRenderFns } from "./PatientFilterPopover.vue?vue&type=template&id=61aa3a5a&"
import script from "./PatientFilterPopover.vue?vue&type=script&lang=ts&"
export * from "./PatientFilterPopover.vue?vue&type=script&lang=ts&"
import style0 from "./PatientFilterPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports